import React from 'react';
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import { PLACES_ROUTE } from "../../../utils/consts";
import { reachGoal } from "../../../utils/metrika/metrika";

import styles from './PlaceNavItem.module.css';

const PlaceNavItem = observer(({ place }) => {
    if (!place?.id) {
        return null;
    }

    const title = place.title || "Интересное место";

    return (
        <div className={styles.navItem}>
            <Link
                to={`${PLACES_ROUTE}/${place.id}`}
                className={styles.navLink}
                aria-label={title}
                title={title}
                onClick={() => {
                    reachGoal(`history.push(${PLACES_ROUTE}/${place.id})`);
                }}
            >
                {title}
            </Link>
        </div>
    );
});

export default PlaceNavItem;